import { render, staticRenderFns } from "./NftManagerSend.vue?vue&type=template&id=5515380a"
import script from "./NftManagerSend.vue?vue&type=script&lang=js"
export * from "./NftManagerSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports